import React, { Fragment } from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { authProvider } from '../../utils/authProvider';

import {
  Collapse,
  Container,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge
} from 'reactstrap';
import '@fortawesome/fontawesome-free/css/all.css';

function UserAvatar(props: any) {
  // If a user avatar is available, return an img tag with the pic
  if (props.user.avatar) {
    return <img
      src={props.user.avatar} alt="user"
      className="rounded-circle align-self-center mr-2"
      style={{ width: '32px' }}></img>;
  }

  // No avatar available, return a default icon
  return <i
    className="far fa-user-circle fa-lg rounded-circle align-self-center mr-2"
    style={{ width: '32px' }}></i>;
}

function AuthNavItem(props: any) {
  // If authenticated, return a dropdown with the user's info and a
  // sign out button
  if (props.isAuthenticated) {
    return (
      <Fragment>
        {/* <NavItem>
          <RouterNavLink to="/cart" className="nav-link" exact>
            <i className="fas fa-shopping-cart mr-1"></i>My Cart</RouterNavLink>
        </NavItem> */}
        {/* <NavItem>
          <RouterNavLink to="/profile" className="nav-link" exact>
            <i className="fas fa-id-card mr-1"></i>Profile</RouterNavLink>
        </NavItem> */}
        <UncontrolledDropdown>
          <DropdownToggle nav caret>
            <UserAvatar user={props.user} />
          </DropdownToggle>
          <DropdownMenu right>
            {/* <h5 className="dropdown-item-text mb-0" onClick={props.editProfileButtonMethod}>{props.user.displayName}</h5>
            <p className="dropdown-item-text text-muted mb-0">{props.user.email}</p> */}
            <h5 className="dropdown-item-text mb-0" onClick={props.editProfileButtonMethod}>{props.userDB?.fullName}</h5>
            <p className="dropdown-item-text text-muted mb-0">{props.userDB?.userId == "" ? props.userEmail:props.userDB?.userId }</p>
            {/* <p className="dropdown-item-text text-muted mb-0">{ props.userEmailAdd}</p> */}
            {props.userDB?.userStatus == "Approved" ? (
              <p className="dropdown-item-text text-muted mb-0"><Badge color="success">{props.userDB?.userStatus}</Badge></p>
            ):(
              <p className="dropdown-item-text text-muted mb-0"><Badge color="danger">Pending Approval</Badge></p>
            ) 
            }
            <DropdownItem divider />
            <DropdownItem onClick={props.authButtonMethod}>Sign Out</DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </Fragment>
    );
  }

  // Not authenticated, return a sign in link
  return (
    <NavItem>
      <NavLink onClick={props.authButtonMethod}>Sign In / Sign Up</NavLink>
    </NavItem>
  );
}

export default class NavBar extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      userEmailAdd : ''
    };
  }

  public async GetEmailAdd():Promise<string>{
    let accountInfo = await authProvider.getAccountInfo();
    let email = accountInfo === null ? '' : accountInfo?.account.idToken.email;
    return email;
  }

  async componentDidMount(){
    let email = await this.GetEmailAdd();
    this.setState({userEmailAdd: email});
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    // Only show calendar nav item if logged in
    let privateLink = null;
    if (this.props.isAuthenticated) {
      privateLink = (
        <Fragment>
          <NavItem>
            <RouterNavLink to="/" className="nav-link" >
              <i className="fas fa-chart-line mr-1"></i>&nbsp;Dashboard
            </RouterNavLink>
          </NavItem>
          <NavItem>
            <RouterNavLink to="/users" className="nav-link" >
              <i className="fas fa-users mr-1"></i>&nbsp;Users
            </RouterNavLink>
          </NavItem>
          {/* <NavItem>
            <RouterNavLink to="/usercourses" className="nav-link" >
              <i className="fas fa-play mr-1"></i>&nbsp;User Courses
            </RouterNavLink>
          </NavItem> */}
          <NavItem>
            <RouterNavLink to="/courses" className="nav-link" >
              <i className="fas fa-play mr-1"></i>&nbsp;Courses
            </RouterNavLink>
          </NavItem>
          <NavItem>
            <RouterNavLink to="/organisers" className="nav-link" >
              <i className="fas fa-chalkboard-teacher mr-1"></i>&nbsp;Organisers
            </RouterNavLink>
          </NavItem>
          <NavItem>
            <RouterNavLink to="/marketings" className="nav-link" >
              <i className="fas fa-bullhorn mr-1"></i>&nbsp;Marketings
            </RouterNavLink>
          </NavItem>
          <NavItem>
            <RouterNavLink to="/orders" className="nav-link" >
              <i className="fas fa-dollar-sign mr-1"></i>&nbsp;Orders
            </RouterNavLink>
          </NavItem>
          <NavItem>
            <RouterNavLink to="/feedbacks" className="nav-link" >
              <i className="fas fa-star-half-alt mr-1"></i>&nbsp;Feedbacks
            </RouterNavLink>
          </NavItem>
          <NavItem>
            <RouterNavLink to="/concentrations" className="nav-link" >
              <i className="fas fa-image mr-1"></i>&nbsp;Concentrations
            </RouterNavLink>
          </NavItem>
        </Fragment>
      );
    }
    
    return (
      <div>
        <Navbar color="" dark expand="md" fixed="top" style={{backgroundColor:"#3A3A3C"}}>
          <Container>
            <NavbarBrand href="/">
              {/* <i className="fas fa-globe-americas mr-1"></i>Ultimates Pro */}
              <img src="/images/logo.png" height="40px" alt="Logo"/>
            </NavbarBrand>
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className="mr-auto" navbar>
                {privateLink}
              </Nav>
              <Nav className="justify-content-end" navbar>
                <AuthNavItem
                  editProfileButtonMethod={this.props.editProfileButtonMethod}
                  isAuthenticated={this.props.isAuthenticated}
                  authButtonMethod={this.props.authButtonMethod}
                  user={this.props.user} 
                  userDB={this.props.userDB} 
                  userEmail={this.state.userEmailAdd}
                  />
              </Nav>
            </Collapse>
          </Container>
        </Navbar>
      </div>
    );
  }
}